import {OwlDateTimeIntl} from "ng-pick-datetime";

export class GermanIntl extends OwlDateTimeIntl
{

    /** A label for the cancel button */
    cancelBtnLabel = 'Schliessen';

    /** A label for the set button */
    setBtnLabel = 'Bestätigen';

    /** A label for the range 'from' in picker info */
    rangeFromLabel = 'Von';

    /** A label for the range 'to' in picker info */
    rangeToLabel = 'Bis';
}